const dlugosc = { t: 'Długość', type: 'range', name: 'dlugosc', unit: 'm' }
export default dlugosc